var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13V14H13V13H12Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11V12H10V11H9Z",
    fill: "#030712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15H11V14H10V13H9V15Z",
    fill: "#030712"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11L13 13H14V11H13Z",
    fill: "#030712"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13H15V15H13V14H14L14 13Z",
    fill: "#030712"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10V9H15V11H14L14 10H13Z",
    fill: "#030712"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10H11V12H10V13H12V10Z",
    fill: "#030712"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9V10H11V9H9Z",
    fill: "#030712"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11H3V13H5V11Z",
    fill: "#030712"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15H1V9H7V15ZM2 14H6V10H2V14Z",
    fill: "#030712"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3H11V5H13V3Z",
    fill: "#030712"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7H9V1H15V7ZM10 6H14V2H10V6Z",
    fill: "#030712"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3H3V5H5V3Z",
    fill: "#030712"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7H1V1H7V7ZM2 6H6V2H2V6Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQr);
export default __webpack_public_path__ + "static/media/ic-qr.9e851f7f101bdaa2ef920abdabe3746d.svg";
export { ForwardRef as ReactComponent };